<template>
  <div class="date-filter-inputs">
    <InputRow v-slot="{ validation: { valid } }" :model-value="dateRange[0]" name="dateRangeStart">
      <DatePickerComponent
        v-model="dateRange[0]"
        :type="DatePickerType.DAY"
        :clearable="true"
        :state="valid"
        :tz="tz"
        :placeholder="t('components.event-action.filter.ui.DateFilterUI.from').toString()"
      />
    </InputRow>
    <InputRow v-slot="{ validation: { valid } }" :model-value="dateRange[1]" name="dateRangeEnd">
      <DatePickerComponent
        v-model="dateRange[1]"
        :type="DatePickerType.DAY"
        :clearable="true"
        :state="valid"
        :tz="tz"
        :placeholder="t('components.event-action.filter.ui.DateFilterUI.until').toString()"
      />
    </InputRow>
  </div>
</template>

<script setup lang="ts">
import { useTranslation } from "@/language/translation";

import InputRow from "@/components/shared/form/InputRow.vue";
import { ref } from "vue";
import { DateTime } from "luxon";
import DatePickerComponent from "@/components/shared/DatePickerComponentNew.vue";
import DateFilter from "../filterImplementations/DateFilter";
import { DatePickerType } from "@/graphql";
import injectAsserted from "@/functions/assert/injectAsserted";
import { TimeZoneInjectionKey } from "@/functions/timezoneUtil";

const dateRange = ref<[DateTime | undefined, DateTime | undefined]>([undefined, undefined]);

function getFilter() {
  if (dateRange.value.some((date) => date != null)) {
    return new DateFilter(
      dateRange.value.map((date, index) => {
        if (date == null) {
          return null;
        }
        if (index === 0) {
          return date;
        }
        if (index === 1) {
          let dateTime = date.setZone(tz.value);
          return dateTime.endOf("day");
        }
        throw Error("unexpected number of dates in date filter");
      }) as [null | DateTime, null | DateTime],
    );
  }
  return null;
}

function applyFilter(filter: DateFilter) {
  dateRange.value = filter.date.map((d) => d ?? undefined) as [
    DateTime | undefined,
    DateTime | undefined,
  ];
  if (filter.date[0]?.toMillis() === 0) {
    dateRange.value[0] = DateTime.now();
  }
}
defineExpose({
  getFilter,
  applyFilter,
});

const tz = injectAsserted(TimeZoneInjectionKey);

const { t } = useTranslation();
</script>

<style lang="scss" scoped>
.date-filter-inputs {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
}
</style>
